import { Model as ORMModel, attr } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'


export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr(),
    }
  }
  static reducer(action, Notification, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_NOTIFICATIONS:
        session.Notification.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_NOTIFICATIONS:
        action?.payload?.forEach(newItem => {
          session.Notification.upsert(newItem)
        })
        break
      case Types.ADD_NOTIFICATION:
        const id = action?.payload?.id || getId()
        Notification.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_NOTIFICATION:
        item = Notification.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_NOTIFICATION:
        Notification.withId(action.payload.id).delete()
        break
    }
  }
}
